// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2w42O","insightsList":"newBusinessInsightsMenu_insightsList__2s_Gt","active":"newBusinessInsightsMenu_active__30rH6"};